import { render, staticRenderFns } from "./ModalDeliveryAddress.vue?vue&type=template&id=601c20fe&scoped=true&"
import script from "./ModalDeliveryAddress.vue?vue&type=script&lang=js&"
export * from "./ModalDeliveryAddress.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeliveryAddress.vue?vue&type=style&index=0&id=601c20fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601c20fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('601c20fe')) {
      api.createRecord('601c20fe', component.options)
    } else {
      api.reload('601c20fe', component.options)
    }
    module.hot.accept("./ModalDeliveryAddress.vue?vue&type=template&id=601c20fe&scoped=true&", function () {
      api.rerender('601c20fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/ModalDeliveryAddress.vue"
export default component.exports